import { Injectable } from '@angular/core';

/**
 * Thin wrapper around `window.location.reload()`. `window.location.reload` is not configurable
 * in this project's unit-test environment, so it cannot be spied on directly; injecting
 * this service lets consumers (e.g. `ChunkLoadErrorModalComponent`) be unit-tested by mocking
 * the service instead.
 */
@Injectable({
  providedIn: 'root'
})
export class ReloadService {
  public reload(): void {
    window.location.reload();
  }
}
